// extracted by mini-css-extract-plugin
module.exports = {"table-link":"TableLink_table-link__3G2bl"};